// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__VFXcL","bodyer":"Layout_bodyer__r3eRr","content":"Layout_content__yO8Xs"};